<template>
  <div class="cat-estatus-cedula">
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" @change="cambiarDatos($event)" class="form-control">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un tipo de estatus</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los tipos de estatus</option>        
        <option v-for="(tipoEstatus,index) in tiposDeEstatus" :value="tipoEstatus.TipoEstatusId" :key="index">{{tipoEstatus.Nombre}}</option>
      </select>      
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default {
    data() {
      return {
        enumeraciones,
        tiposDeEstatus: [],
        idDelModelo:null
      }
    },
    props: {            
      parametros:Object,
      valorDefinido:Number,
      idDelInput:String,      
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      }
    },
    computed:{
      
    },
    methods: {
      /**
       * Metodo para asignar la llave del elmento seleccionado del catalogo 011TiposEstatus
       * @param {object} evento [evento emitido por el select]
       */
      cambiarDatos(evento){
        this.idDelModelo = evento.target.value;
        const valoresDelCatalogo =
        {
          llave: this.idDelInput,
          valor: evento.target.value 
        }
        let tipoEstatusObj = this.obtenerTipoEstatusObj(evento.target.value);
        this.$store.dispatch("A_SINOJ_Catalogos_establecer011TiposEstatus",valoresDelCatalogo);
        this.$emit("valorParaElPadre",evento,tipoEstatusObj);
      },
      obtenerTipoEstatusObj: function(tipoEstatusId) {
        let id = parseInt(tipoEstatusId);
        let tipoEstatus = null;
        this.tiposDeEstatus.filter(teBD => teBD.TipoEstatusId == id).forEach(te => {tipoEstatus = te});
        return tipoEstatus;
      },
      /**
       * Metodo para llenar catalogo 011TiposEstatus mediante el llamado de la API
       */
      cargarTiposDeEstatus: function() {
        // definimos metodo de API
        const SERVIDOR = api.conexion;
        const METODO_API = api.SINOJ.catalogos.C011TiposEstatus;
        let urlApi = SERVIDOR + METODO_API;
        // creamos la peticion con el formulario
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {};
        
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba;
        
        let peticionMetodoGetZonasAPI = this.parametros;
        // contruir header de la peticion
        let peticionArchivos = false;
        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos);

        axios.post(urlApi, peticionMetodoGetZonasAPI, headerPeticion)
                .then(respuesta => {            
                    if (respuesta.data.SiHayError) {
                        console.log(respuesta); 
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    } else { 
                        this.tiposDeEstatus = respuesta.data.TiposEstatus;
                    }
                })
                .catch(excepcion => {
                    console.log(excepcion);
                    comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
                }
        ) // axios.post
      }
    }, 
    mounted(){
      // establecer valor default
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

        const valoresDelCatalogo = {
          llave: this.idDelInput,
          valor: this.idDelModelo
        }
      this.$store.dispatch("A_SINOJ_Catalogos_establecer011TiposEstatus", valoresDelCatalogo);
    },
    created() {
      this.cargarTiposDeEstatus();
    }
  }
</script>
<style>
.cat-estatus-cedula .form-control {
  background-color: white !important;
        color: black !important;
}
</style>



// WEBPACK FOOTER //
// src/components/SINOJ/Comun/Catalogos/C011TiposEstatus.vue